import React, { useState } from "react";
import MainCalculatorsList from "./CountriesMainCalculatorsList/JordanMainCalculator";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة فاتورة الكهرباء في الأردن - احسب تكلفة استهلاكك الشهري";
const DESCRIPTION =
  "احسب قيمة فاتورة الكهرباء بدقة باستخدام التعريفة الرسمية المدعومة وغير المدعومة في الأردن. أدخل استهلاكك واحصل على حساب تفصيلي فوري للشرائح - أداة مجانية سهلة الاستخدام";
const KEYWORDS = "حاسبة فاتورة الكهرباء الأردن, حساب استهلاك الكهرباء, تعريفة الكهرباء المدعومة, أسعار الطاقة الكهربائية الأردن, كيلووات ساعة";
const OG_URL =
  "https://do-calculate.com/calculator/ar/countries/JO/calculators-list/electricity-calculator/";
// بيانات الأجهزة المنزلية
const APPLIANCES_DATA = {
  heating: [
    { name: "مكيف تبريد وتدفئة", power: 1800, hours: 6, emoji: "🌡️" },
    { name: "دفاية كهربائية", power: 2200, hours: 5, emoji: "🔥" },
    { name: "سخان ماء كهربائي", power: 2000, hours: 2, emoji: "💧" },
  ],
  kitchen: [
    { name: "ثلاجة عادية", power: 180, hours: 24, emoji: "🧊" },
    { name: "فرن كهربائي", power: 2500, hours: 1, emoji: "🍕" },
    { name: "ميكروويف", power: 1200, hours: 0.5, emoji: "🍲" },
    { name: "غلاية كهربائية", power: 2000, hours: 0.3, emoji: "☕" },
  ],
  laundry: [
    { name: "غسالة أوتوماتيك", power: 700, hours: 1, emoji: "👕" },
    { name: "نشافة ملابس", power: 3000, hours: 1, emoji: "🌪️" },
    { name: "مكواة بخار", power: 1400, hours: 0.5, emoji: "👔" },
  ],
  electronics: [
    { name: "تلفزيون LED", power: 120, hours: 6, emoji: "📺" },
    { name: "كمبيوتر مكتبي", power: 250, hours: 8, emoji: "🖥️" },
    { name: "لابتوب", power: 65, hours: 5, emoji: "💻" },
    { name: "راوتر إنترنت", power: 12, hours: 24, emoji: "📡" },
  ]
};
function ElectricityCalculator() {
  const [consumption, setConsumption] = useState("");
  const [tariffType, setTariffType] = useState("supported");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [applianceHours, setApplianceHours] = useState({});
  // التاريخ الحالي
  const today = new Date().toLocaleDateString('ar-JO', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  const calculateBill = () => {
    try {
      setError("");
      const kwh = parseFloat(consumption);
      if (isNaN(kwh) || kwh <= 0) {
        setError("يرجى إدخال قيمة استهلاك صالحة");
        return;
      }
      let totalCost = 0;
      let tier1Cost = 0;
      let tier2Cost = 0;
      let tier3Cost = 0;
      let tier1Kwh = 0;
      let tier2Kwh = 0;
      let tier3Kwh = 0;
      if (tariffType === "supported") {
        // التعريفة المدعومة
        if (kwh <= 300) {
          tier1Kwh = kwh;
          tier1Cost = kwh * 0.050;
          totalCost = tier1Cost;
        } else if (kwh <= 600) {
          tier1Kwh = 300;
          tier2Kwh = kwh - 300;
          tier1Cost = 300 * 0.050;
          tier2Cost = (kwh - 300) * 0.100;
          totalCost = tier1Cost + tier2Cost;
        } else {
          tier1Kwh = 300;
          tier2Kwh = 300;
          tier3Kwh = kwh - 600;
          tier1Cost = 300 * 0.050;
          tier2Cost = 300 * 0.100;
          tier3Cost = (kwh - 600) * 0.200;
          totalCost = tier1Cost + tier2Cost + tier3Cost;
        }
      } else {
        // التعريفة غير المدعومة
        if (kwh <= 1000) {
          tier1Kwh = kwh;
          tier1Cost = kwh * 0.120;
          totalCost = tier1Cost;
        } else {
          tier1Kwh = 1000;
          tier2Kwh = kwh - 1000;
          tier1Cost = 1000 * 0.120;
          tier2Cost = (kwh - 1000) * 0.150;
          totalCost = tier1Cost + tier2Cost;
        }
      }
      setResult({
        totalCost,
        tier1Cost,
        tier2Cost,
        tier3Cost,
        tier1Kwh,
        tier2Kwh,
        tier3Kwh,
        totalKwh: kwh
      });
    } catch (error) {
      setError("حدث خطأ في الحساب");
    }
  };
  const updateApplianceHours = (category, name, hours) => {
    const id = `${category}-${name}`;
    const updatedHours = {
      ...applianceHours,
      [id]: parseFloat(hours) || 0
    };
    setApplianceHours(updatedHours);
    let total = 0;
    Object.entries(APPLIANCES_DATA).forEach(([cat, appliances]) => {
      appliances.forEach(app => {
        const appId = `${cat}-${app.name}`;
        const hrs = updatedHours[appId] || 0;
        if (hrs > 0) {
          const daily = (app.power * hrs) / 1000;
          total += daily * 30;
        }
      });
    });
    if (total > 0) {
      setConsumption(total.toFixed(1));
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
         <div className="bg-success text-white text-center" style={{ height: '40px', }}>
            <h1 style={{ fontSize: "17px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div className="p-3">
                <p>
                  هل تريد معرفة القيمة المتوقعة لفاتورتك الشهرية؟ أداتنا توفر لك حساباً
                  دقيقاً لتكلفة استهلاك الكهرباء وفق التعريفة الرسمية المعتمدة في الأردن. ببساطة،
                  أدخل استهلاكك الشهري بالكيلووات ساعة واحصل فوراً على التفاصيل الكاملة
                  للفاتورة مع توزيع التكلفة على الشرائح المختلفة.
                </p>
                <p>
                  تعتمد الحاسبة على نظام التسعير الرسمي المعتمد من هيئة تنظيم قطاع الطاقة والمعادن
                  في الأردن، والذي يقسم الاستهلاك المنزلي المدعوم إلى ثلاث شرائح بأسعار متفاوتة.
                  الاستهلاك حتى 300 كيلووات يخضع لسعر 50 فلس، من 301-600 بسعر 100 فلس، وما
                  يزيد عن 600 بسعر 200 فلس. هذا النظام يشجع المواطنين على ترشيد الاستهلاك.
                </p>
                <p>
                  معرفة تفاصيل فاتورتك تساعدك على التخطيط المالي الأفضل وفهم كيفية توزيع
                  التكاليف. كما يمكنك استخدام قسم حساب استهلاك الأجهزة أدناه لمعرفة مقدار
                  الطاقة التي يستهلكها كل جهاز في منزلك، مما يساعدك على اتخاذ قرارات ذكية
                  لتوفير الطاقة والمال.
                </p>
                <hr />
              </div>
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                 <div className="bg-success text-white text-center">
                  <h2 style={{ fontSize: "16px", margin: 0 }}>{TITLE}</h2>
                </div>
                <div className="bg-warning text-black text-center p-2">
                  <u><b>ملاحظة هامة</b>:</u>{" "}
                  <b>
                    تاريخ آخر تحديث: <time dateTime={new Date().toISOString().split('T')[0]}>{today}</time>
                  </b>
                </div>
                <div className="p-3">
                  <div className="form-group mb-3">
                    <label><strong>نوع التعريفة:</strong></label>
                    <select
                      className="form-control"
                      value={tariffType}
                      onChange={(e) => setTariffType(e.target.value)}
                    >
                      <option value="supported">🏠 تعريفة مدعومة (للأردنيين)</option>
                      <option value="unsupported">🏢 تعريفة غير مدعومة</option>
                    </select>
                  </div>
                  <div className="form-group mb-3">
                    <label htmlFor="consumption"><strong>الاستهلاك الشهري (كيلووات ساعة):</strong></label>
                    <input
                      id="consumption"
                      type="number"
                      value={consumption}
                      onChange={(e) => setConsumption(e.target.value)}
                      className="form-control mb-2"
                      placeholder="مثال: 450"
                    />
                  </div>
                  {tariffType === "supported" && (
                    <div className="alert alert-info">
                      <strong>📊 نظام الشرائح المدعومة:</strong>
                      <ul style={{ marginBottom: 0, marginTop: "10px", paddingRight: "20px" }}>
                        <li>الشريحة الأولى (1-300 كيلووات): <strong>50 فلس</strong></li>
                        <li>الشريحة الثانية (301-600 كيلووات): <strong>100 فلس</strong></li>
                        <li>الشريحة الثالثة (+600 كيلووات): <strong>200 فلس</strong></li>
                      </ul>
                    </div>
                  )}
                  {tariffType === "unsupported" && (
                    <div className="alert alert-info">
                      <strong>📊 نظام الشرائح غير المدعومة:</strong>
                      <ul style={{ marginBottom: 0, marginTop: "10px", paddingRight: "20px" }}>
                        <li>الشريحة الأولى (1-1000 كيلووات): <strong>120 فلس</strong></li>
                        <li>الشريحة الثانية (+1000 كيلووات): <strong>150 فلس</strong></li>
                      </ul>
                    </div>
                  )}
                  <br />
                  <button
                    className="text-white"
                    style={{ fontSize: "20px", marginLeft: "10px", padding: "10px 30px", border: "none", borderRadius: "5px", backgroundColor: "#0d5e3a" }}
                    onClick={calculateBill}
                  >
                    احسب                  </button>
                </div>
                { error !== "" ? (
                  <p className="p-3 mb-2 bg-warning text-white">خطأ: {error}</p>
                ) : (
                  result !== null && (
                     <div className="bg-success text-white text-center">
                      <p style={{ fontSize: "18px", marginBottom: "10px" }}>
                        <strong>💰 التكلفة الإجمالية: {result.totalCost.toFixed(2)} دينار</strong>
                      </p>
                      {tariffType === "supported" && (
                        <div style={{ fontSize: "14px" }}>
                          {result.tier1Kwh > 0 && (
                            <p>
                              الشريحة الأولى: {result.tier1Kwh} كيلووات × 0.050 = {result.tier1Cost.toFixed(2)} دينار
                            </p>
                          )}
                          {result.tier2Kwh > 0 && (
                            <p>
                              الشريحة الثانية: {result.tier2Kwh} كيلووات × 0.100 = {result.tier2Cost.toFixed(2)} دينار
                            </p>
                          )}
                          {result.tier3Kwh > 0 && (
                            <p>
                              الشريحة الثالثة: {result.tier3Kwh} كيلووات × 0.200 = {result.tier3Cost.toFixed(2)} دينار
                            </p>
                          )}
                        </div>
                      )}
                      {tariffType === "unsupported" && (
                        <div style={{ fontSize: "14px" }}>
                          {result.tier1Kwh > 0 && (
                            <p>
                              الشريحة الأولى: {result.tier1Kwh} كيلووات × 0.120 = {result.tier1Cost.toFixed(2)} دينار
                            </p>
                          )}
                          {result.tier2Kwh > 0 && (
                            <p>
                              الشريحة الثانية: {result.tier2Kwh} كيلووات × 0.150 = {result.tier2Cost.toFixed(2)} دينار
                            </p>
                          )}
                        </div>
                      )}
                    </div>
                  )
                )}
              </div>
              <div className="col-sm-12 col-md-5">
                {/* جدول الأسعار الرسمية */}
                <div className="calculatorStyle">
                   <div className="bg-success text-white text-center">
                    <h3 style={{ fontSize: "16px", margin: 0 }}>📋 جدول الأسعار الرسمية</h3>
                  </div>
                  <div className="p-3">
                    <div className="mb-3">
                      <strong>🏠 التعريفة المدعومة</strong>
                      <table className="table table-sm mt-2" style={{ tableLayout: "fixed" }}>
                        <tbody>
                          <tr>
                            <td style={{ width: "50%" }}>1-300 كيلووات</td>
                            <td style={{ width: "50%" }}>
                              <strong>50 فلس</strong>
                            </td>
                          </tr>
                          <tr>
                            <td>301-600 كيلووات</td>
                            <td>
                              <strong>100 فلس</strong>
                            </td>
                          </tr>
                          <tr>
                            <td>+600 كيلووات</td>
                            <td>
                              <strong>200 فلس</strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div>
                      <strong>🏢 التعريفة غير المدعومة</strong>
                      <table className="table table-sm mt-2" style={{ tableLayout: "fixed" }}>
                        <tbody>
                          <tr>
                            <td style={{ width: "50%" }}>1-1000 كيلووات</td>
                            <td style={{ width: "50%" }}>
                              <strong>120 فلس</strong>
                            </td>
                          </tr>
                          <tr>
                            <td>+1000 كيلووات</td>
                            <td>
                              <strong>150 فلس</strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <br />
                {/* أمثلة سريعة */}
                <div className="calculatorStyle">
                   <div className="bg-success text-white text-center">
                    <h3 style={{ fontSize: "16px", margin: 0 }}>🧮 أمثلة سريعة</h3>
                  </div>
                  <div className="p-3">
                    <div className="mb-2 p-2" style={{ border: "2px solid #0d5e3a", borderRadius: "5px" }}>
                      <strong>200 كيلووات (مدعومة):</strong>
                      <br />
                      200 × 0.050 = <strong>10 دينار</strong>
                    </div>
                    <div className="mb-2 p-2" style={{ border: "2px solid #0d5e3a", borderRadius: "5px" }}>
                      <strong>450 كيلووات (مدعومة):</strong>
                      <br />
                      (300 × 0.050) + (150 × 0.100) = <strong>30 دينار</strong>
                    </div>
                    <div className="p-2" style={{ border: "2px solid #0d5e3a", borderRadius: "5px" }}>
                      <strong>700 كيلووات (مدعومة):</strong>
                      <br />
                      (300 × 0.050) + (300 × 0.100) + (100 × 0.200) = <strong>65 دينار</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            {/* قسم حساب الاستهلاك من الأجهزة */}
            <div className="row">
              <div className="col-sm-12 col-md-12 calculatorStyle">
                 <div className="bg-success text-white text-center">
                  <h2 style={{ fontSize: "16px", margin: 0 }}>
                    🔌 احسب استهلاكك من أجهزتك المنزلية
                  </h2>
                </div>
                <div className="p-3">
                  <p>حدد ساعات تشغيل أجهزتك اليومية وسيتم حساب الاستهلاك تلقائياً</p>
                  {Object.entries(APPLIANCES_DATA).map(([category, appliances]) => (
                    <div key={category} className="mb-4">
                      <h3 className="bg-success text-white text-center">
                        {category === 'heating' && '🔥 التدفئة والتكييف'}
                        {category === 'kitchen' && '🍳 أجهزة المطبخ'}
                        {category === 'laundry' && '🧺 الغسيل والعناية'}
                        {category === 'electronics' && '📺 الإلكترونيات'}
                      </h3>
                      <div className="row">
                        {appliances.map((app) => {
                          const id = `${category}-${app.name}`;
                          const hours = applianceHours[id] || 0;
                          const monthly = hours > 0 ? ((app.power * hours) / 1000) * 30 : ((app.power * app.hours) / 1000) * 30;
                          // حساب التكلفة بناءً على التعريفة المدعومة
                          let cost = 0;
                          if (monthly <= 300) {
                            cost = monthly * 0.050;
                          } else if (monthly <= 600) {
                            cost = (300 * 0.050) + ((monthly - 300) * 0.100);
                          } else {
                            cost = (300 * 0.050) + (300 * 0.100) + ((monthly - 600) * 0.200);
                          }
                          return (
                            <div className="col-sm-12 col-md-4 mb-3" key={id}>
                              <div style={{ minHeight: "180px", border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                                <div className="bg-success text-white text-center">
                                  <strong style={{ fontSize: "14px" }}>{app.emoji} {app.name}</strong>
                                </div>
                                <div className="p-3">
                                  <small className="text-muted d-block mb-2">
                                    القدرة: {app.power} واط
                                  </small>
                                  <div className="form-group mb-2">
                                    <label style={{ fontSize: "12px" }}>ساعات التشغيل يومياً:</label>
                                    <input
                                      type="number"
                                      className="form-control form-control-sm"
                                      value={hours || ''}
                                      onChange={(e) => updateApplianceHours(category, app.name, e.target.value)}
                                      placeholder={`مثال: ${app.hours}`}
                                      min="0"
                                      step="0.5"
                                    />
                                  </div>
                                  <div className="d-block" style={{ color: "#0d5e3a" }}>
                                    <small>
                                      الاستهلاك: <strong>{monthly.toFixed(1)} كيلووات/شهر</strong>
                                    </small>
                                    <br />
                                    <small>
                                      التكلفة: <strong>{cost.toFixed(2)} دينار</strong>
                                    </small>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <hr />
            {/* نصائح التوفير */}
            <div className="row">
              <div className="col-sm-12 col-md-12 calculatorStyle">
                 <div className="bg-success text-white text-center">
                  <h2 style={{ fontSize: "16px", margin: 0 }}>💡 نصائح لتوفير الكهرباء</h2>
                </div>
                <div className="p-3">
                  <div className="row">
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>استخدم مصابيح LED</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            استبدل المصابيح العادية بمصابيح LED الموفرة للطاقة. توفر حتى 80% من استهلاك الإنارة وتدوم 25 مرة أطول من المصابيح التقليدية
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>ضبط حرارة المكيف</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            اضبط المكيف على 24 درجة مئوية بدلاً من 20 درجة. كل درجة تقلل الاستهلاك بنسبة 8%، مما يوفر حتى 30% من تكلفة التكييف شهرياً
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>صيانة دورية للثلاجة</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            نظف ملفات الثلاجة الخلفية كل 3 أشهر وتأكد من إحكام إغلاق الباب. هذا يحسن الكفاءة بنسبة 20% ويقلل الاستهلاك بشكل ملحوظ
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>افصل الأجهزة غير المستخدمة</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            الأجهزة في وضع الاستعداد تستهلك 5-10% من الكهرباء. افصلها من الكهرباء أو استخدم مشتركات بمفتاح لتوفير حقيقي على الفاتورة
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>عزل المنزل بشكل جيد</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            تحسين العزل الحراري للنوافذ والأبواب يقلل الحاجة للتدفئة والتبريد بنسبة تصل إلى 30%، مما يوفر استهلاك كبير من الطاقة
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>اغسل بالماء البارد</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            90% من طاقة الغسالة تذهب لتسخين الماء. الغسيل بالماء البارد فعال للملابس ويوفر استهلاك كبير من الطاقة شهرياً
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>استفد من ضوء النهار</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            افتح الستائر نهاراً واستغل الإضاءة الطبيعية بدلاً من المصابيح، مما يوفر استهلاك الإنارة بشكل كامل خلال ساعات النهار
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>استبدل الأجهزة القديمة</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            الأجهزة الحديثة ذات تصنيف الطاقة A+++ تستهلك أقل بنسبة 50-70% من الموديلات القديمة، خاصة الثلاجات والمكيفات والغسالات
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      {/* الأسئلة الشائعة */}
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">كيف يتم حساب فاتورة الكهرباء في الأردن؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>نظام الشرائح للتعريفة المدعومة</h2>
                  </u>
                  <p>
                    يتم حساب فاتورة الكهرباء في الأردن بناءً على كمية الاستهلاك الشهري
                    بالكيلوواط/ساعة ونوع التعرفة (مدعومة أو غير مدعومة). للتعريفة المدعومة،
                    يتم تقسيم الاستهلاك إلى ثلاث شرائح:
                  </p>
                  <ul>
                    <li>الشريحة الأولى (1-300 كيلوواط): 50 فلس لكل كيلوواط</li>
                    <li>الشريحة الثانية (301-600 كيلوواط): 100 فلس لكل كيلوواط</li>
                    <li>الشريحة الثالثة (أكثر من 600 كيلوواط): 200 فلس لكل كيلوواط</li>
                  </ul>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>مثال حسابي</h2>
                  </u>
                  <p>
                    إذا كان استهلاكك 450 كيلوواط/ساعة شهرياً (تعريفة مدعومة):
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    الشريحة الأولى: 300 × 0.050 = 15 دينار
                    <br />
                    الشريحة الثانية: 150 × 0.100 = 15 دينار
                    <br />
                    <strong>الإجمالي: 30 دينار</strong>
                  </div>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">ما الفرق بين التعرفة المدعومة وغير المدعومة؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>التعريفة المدعومة</h2>
                  </u>
                  <p>
                    مخصصة للمنازل الأردنية المستحقة للدعم. تكون أسعار الكيلوواط/ساعة
                    فيها أقل وتبدأ من 50 فلس للشريحة الأولى. تشمل ثلاث شرائح بأسعار
                    متدرجة (50، 100، 200 فلس).
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>التعريفة غير المدعومة</h2>
                  </u>
                  <p>
                    تُطبق على غير المستفيدين من الدعم أو على العدادات الإضافية.
                    تكون فيها تكلفة الكهرباء أعلى لكل كيلوواط/ساعة:
                  </p>
                  <ul>
                    <li>1-1000 كيلوواط: 120 فلس</li>
                    <li>أكثر من 1000 كيلوواط: 150 فلس</li>
                  </ul>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">كيف يمكن معرفة كمية الاستهلاك الشهري؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>طرق معرفة الاستهلاك</h2>
                  </u>
                  <p>
                    يمكن معرفة الاستهلاك الشهري للكهرباء من خلال:
                  </p>
                  <ul>
                    <li><strong>قراءة عداد الكهرباء:</strong> قارن القراءة الحالية بالقراءة السابقة</li>
                    <li><strong>فاتورة الكهرباء:</strong> كمية الاستهلاك موضحة بالكيلوواط/ساعة</li>
                    <li><strong>حاسبة فاتورة الكهرباء:</strong> على موقع هيئة تنظيم قطاع الطاقة والمعادن</li>
                    <li><strong>تطبيق شركة الكهرباء:</strong> يوفر معلومات تفصيلية عن الاستهلاك</li>
                  </ul>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">لماذا ترتفع فاتورة الكهرباء في بعض الأشهر؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>الأسباب الرئيسية</h2>
                  </u>
                  <p>
                    ترتفع فاتورة الكهرباء غالباً بسبب:
                  </p>
                  <ul>
                    <li><strong>زيادة الاستهلاك:</strong> استخدام مكثف للمكيفات صيفاً أو المدافئ شتاءً</li>
                    <li><strong>الانتقال لشريحة أعلى:</strong> تجاوز حد 300 أو 600 كيلوواط يرفع السعر</li>
                    <li><strong>الأجهزة عالية الاستهلاك:</strong> المكيفات والسخانات تستهلك طاقة كبيرة</li>
                    <li><strong>طول مدة التشغيل:</strong> تشغيل الأجهزة لساعات طويلة يومياً</li>
                    <li><strong>الأجهزة القديمة:</strong> تستهلك أضعاف الموديلات الحديثة</li>
                  </ul>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">كيف أعرف استهلاك كل جهاز في منزلي؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>معادلة حساب الاستهلاك</h2>
                  </u>
                  <p>
                    لحساب استهلاك أي جهاز كهربائي، استخدم المعادلة التالية:
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    <strong>الاستهلاك الشهري = (قدرة الجهاز بالواط × ساعات التشغيل يومياً ÷ 1000) × 30 يوم</strong>
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>مثال عملي</h2>
                  </u>
                  <p>
                    مكيف بقدرة 1800 واط يعمل 6 ساعات يومياً:
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    (1800 × 6 ÷ 1000) × 30 = 324 كيلوواط شهرياً
                    <br />
                    التكلفة بالتعريفة المدعومة:
                    <br />
                    (300 × 0.050) + (24 × 0.100) = 17.40 دينار
                  </div>
                  <p>
                    يمكنك استخدام قسم "حساب استهلاك الأجهزة" أعلاه لمعرفة استهلاك
                    جميع أجهزتك المنزلية بسهولة.
                  </p>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">كيف أخفض قيمة فاتورة الكهرباء؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>نصائح عملية للتوفير</h2>
                  </u>
                  <ul>
                    <li>استبدل المصابيح بـ LED (توفير 50-80 كيلوواط)</li>
                    <li>اضبط المكيف على 24 درجة مئوية (توفير 100-150 كيلوواط)</li>
                    <li>افصل الأجهزة غير المستخدمة من الكهرباء (توفير 15-30 كيلوواط)</li>
                    <li>نظف فلاتر المكيف شهرياً (تحسين الكفاءة 15-20%)</li>
                    <li>استخدم الغسالة بحمولة كاملة (تقليل عدد مرات التشغيل)</li>
                    <li>حسّن عزل المنزل الحراري (تقليل حمل التدفئة/التبريد 30%)</li>
                    <li>استبدل الأجهزة القديمة بموفرة للطاقة (توفير 50-100 كيلوواط)</li>
                    <li>استغل ضوء النهار الطبيعي (توفير استهلاك الإنارة نهاراً)</li>
                  </ul>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">هل الأجهزة المطفأة تستهلك كهرباء؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>الاستهلاك الخفي (Standby Power)</h2>
                  </u>
                  <p>
                    نعم! الأجهزة في وضع الاستعداد (Standby Mode) تستهلك طاقة باستمرار
                    حتى وهي "مطفأة". التلفزيون، أجهزة الألعاب، الشواحن، الميكروويف،
                    وأجهزة الكمبيوتر - كلها تستهلك كهرباء في وضع الاستعداد.
                  </p>
                  <div className="p-3 mb-2 bg-warning text-dark">
                    <strong>⚠️ تنبيه:</strong> هذا الاستهلاك الخفي قد يصل لـ 5-10% من
                    فاتورتك الشهرية!
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>الحل</h2>
                  </u>
                  <p>
                    استخدم مشتركات كهربائية بمفتاح أو افصل الأجهزة من الكهرباء عند
                    عدم استخدامها. هذا يمكن أن يوفر 10-20 دينار شهرياً حسب عدد الأجهزة.
                  </p>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ElectricityCalculator;